/* eslint-disable */
import React, { useMemo } from "react";
import {
  Box,
  Flex,
  Text,
  Badge,
  Button,
  useColorModeValue,
} from "@chakra-ui/react";
import { AgGridProvider,AgGridReact } from "ag-grid-react";
import { AllCommunityModule } from "ag-grid-community";
import Card from "components/card/Card";

export default function ComplexTable({ tableData = [], title = "Data Ticket" }) {
  const textColor = useColorModeValue("secondaryGray.900", "white");
const modules = [AllCommunityModule];
  const StatusBadge = (params) => {
    const value = params.value || "-";

    const color =
      value === "selesai"
        ? "green"
        : value === "diproses"
        ? "orange"
        : value === "baru"
        ? "blue"
        : "gray";

    return (
      <Badge colorScheme={color} variant="subtle">
        {value.toUpperCase()}
      </Badge>
    );
  };

  const PriorityBadge = (params) => {
    const value = params.value || "-";

    const color =
      value === "tinggi"
        ? "red"
        : value === "sedang"
        ? "orange"
        : "green";

    return (
      <Badge colorScheme={color} variant="solid">
        {value.toUpperCase()}
      </Badge>
    );
  };

  const columnDefs = useMemo(
    () => [
      {
        headerName: "Subject",
        field: "subject",
        flex: 1.5,
        minWidth: 220,
        filter: true,
        cellStyle: {
          fontWeight: "700",
        },
      },
      {
        headerName: "Kategori",
        field: "category.name",
        flex: 1,
        minWidth: 150,
        filter: true,
        valueGetter: (params) => params.data?.category?.name || "-",
      },
      {
        headerName: "Status",
        field: "status",
        flex: 1,
        minWidth: 130,
        filter: true,
        cellRenderer: StatusBadge,
      },
      {
        headerName: "Prioritas",
        field: "urgensi",
        flex: 1,
        minWidth: 140,
        filter: true,
        cellRenderer: PriorityBadge,
      },
      {
        headerName: "Tanggal",
        field: "created_at",
        flex: 1,
        minWidth: 140,
        filter: true,
        valueFormatter: (params) => {
          if (!params.value) return "-";
          return new Date(params.value).toLocaleDateString("id-ID");
        },
      },
    ],
    []
  );

  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      resizable: true,
      filter: true,
    }),
    []
  );

  return (
    <Card flexDirection="column" w="100%" px="0px">
      <Flex px="25px" mb="18px" justifyContent="space-between" align="center">
        <Box>
          <Text color={textColor} fontSize="22px" fontWeight="800">
            {title}
          </Text>
          <Text fontSize="sm" color="gray.500">
            Monitoring dan pengelolaan ticket helpdesk
          </Text>
        </Box>
      </Flex>

      <Box px="20px" pb="20px">
        <Box
          className="ag-theme-quartz"
          w="100%"
          h="430px"
          sx={{
            ".ag-root-wrapper": {
              borderRadius: "18px",
              border: "1px solid #edf2f7",
              overflow: "hidden",
            },
            ".ag-header": {
              background: "#f8fafc",
              fontWeight: "800",
            },
            ".ag-row": {
              fontSize: "14px",
            },
          }}
        >
          <AgGridProvider modules={modules}>
             <AgGridReact
            rowData={tableData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            pagination={true}
            paginationPageSize={10}
            rowHeight={54}
            animateRows={true}
          />
          </AgGridProvider>
         
        </Box>
      </Box>
    </Card>
  );
}